<template>
  <div class='my-5'>
    <span class="mr-3">
      <span>
        <button type='button' class='btn btn-sm' onclick="document.querySelector('#split-meipian-orders').click()">分离美篇订单</button>
      </span>
    </span>
    <form id="split-meipian-orders-form" enctype="multipart/form-data" method="post" action="/api/yinjie">
      <input accept=".xlsx" name="file" type="file" id="split-meipian-orders" style="display:none" v-on:change='$event.target.parentNode.submit()'>
      <input type="hidden" name="name" value="import-meipian-orders">
    </form>
  </div>
</template>

<script>
export default {
  name: 'yinjie',
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang='scss'>
  .orders-operation{
    display: inline-block;
  }
</style>
